import { render, staticRenderFns } from "./FormFileUploadsQuestionSettings.vue?vue&type=template&id=38b23a93"
import script from "./FormFileUploadsQuestionSettings.vue?vue&type=script&lang=js"
export * from "./FormFileUploadsQuestionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports